/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import React from "react";

import { usePlayerComponents } from "../../../../../../shared/context/PlayerComponentsContext";
import { usePlayerTranslation } from "../../../../../../shared/context/PlayerTranslationContext";
import AirPlayIcon from "../../../../../../shared/icons/player/AirPlay.svg";
import { usePlayerSettings } from "../../../../../BasePlayer";

import { useAirPlay } from "./useAirPlay";

export const AirPlay = ({}) => {
  const { isCasting, hasAirPlaySupport, toggleAirPlay } = useAirPlay();

  const {
    ui: { tooltipOffset },
  } = usePlayerSettings();

  const { t } = usePlayerTranslation();
  const { Button } = usePlayerComponents();
  const label = t("PLAYER_TOOLTIP_AIRPLAY");

  if (!hasAirPlaySupport) {
    return null;
  }

  return (
    <Button
      variant={isCasting ? "primary" : "secondary"}
      tooltip={label}
      tooltipOffset={tooltipOffset}
      aria-label={label}
      iconOnly
      onClick={toggleAirPlay}
    >
      <AirPlayIcon aria-hidden="true" focusable="false" />
    </Button>
  );
};
